import React from 'react';
import { detectSearchPlatform, getPlatformDisplayName } from '../../utils/propertyPlatforms';
import Sheet from '../ui/Sheet';
import Button from '../ui/Button';
import { Check, AlertTriangle } from '../../icons';

const SearchModal = ({
  isOpen,
  onClose,
  onSubmit,
  searchName,
  setSearchName,
  searchUrl,
  setSearchUrl,
}) => {
  // Detect platform from URL in real-time
  const trimmedUrl = (searchUrl || '').trim();
  const detectedPlatform = trimmedUrl ? detectSearchPlatform(trimmedUrl) : null;
  const platformName = detectedPlatform ? getPlatformDisplayName(detectedPlatform) : null;

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!detectedPlatform) {
      alert("Unsupported URL. Please enter a search URL from Bazaraki, BuySellCyprus, or DOM.com.cy.");
      return;
    }
    
    onSubmit(detectedPlatform);
  };

  return (
    <Sheet
      isOpen={isOpen}
      onClose={onClose}
      mode="sheet"
      size="md"
      title="Track new search"
      aria-label="Track new search"
      footer={
        <div className="flex justify-end gap-2">
          <Button variant="secondary" onClick={onClose}>Cancel</Button>
          <Button variant="primary" type="submit" form="search-add-form" disabled={!detectedPlatform}>
            Add search
          </Button>
        </div>
      }
    >
      <form id="search-add-form" onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label htmlFor="newSearchUrl" className="label">Search URL *</label>
          <input
            type="url"
            id="newSearchUrl"
            value={searchUrl}
            onChange={(e) => setSearchUrl(e.target.value)}
            placeholder="Paste a search URL from Bazaraki, BuySellCyprus, or DOM.com.cy"
            required
            autoFocus
            className="input"
          />
          {trimmedUrl && (
            <div className={`mt-2 text-xs flex items-center gap-1.5 ${detectedPlatform ? 'text-accent' : 'text-danger'}`}>
              {detectedPlatform ? <Check className="w-3.5 h-3.5" /> : <AlertTriangle className="w-3.5 h-3.5" />}
              {detectedPlatform ? `Detected: ${platformName}` : 'Unsupported URL format'}
            </div>
          )}
        </div>

        <div>
          <label htmlFor="newSearchName" className="label">Search name *</label>
          <input
            type="text"
            id="newSearchName"
            value={searchName}
            onChange={(e) => setSearchName(e.target.value)}
            placeholder="e.g., Larnaca 3-Bed Houses < €2000"
            required
            className="input"
          />
        </div>

        <div className="text-xs text-muted space-y-1.5 bg-page border border-line rounded-xl p-3">
          <p>
            <strong className="text-secondary">Bazaraki:</strong> Paste the search URL directly from your browser, e.g.{' '}
            <code className="text-[11px] bg-card px-1 py-0.5 rounded">bazaraki.com/real-estate-for-sale/houses/...</code>
          </p>
          <p>
            <strong className="text-secondary">BuySellCyprus:</strong> Paste the search page URL, e.g.{' '}
            <code className="text-[11px] bg-card px-1 py-0.5 rounded">buysellcyprus.com/properties-for-sale/location-paphos/...</code>
          </p>
          <p>
            <strong className="text-secondary">DOM.com.cy:</strong> Paste the catalog URL, e.g.{' '}
            <code className="text-[11px] bg-card px-1 py-0.5 rounded">dom.com.cy/en/catalog/sale/city-larnaca/type-house/...</code>
          </p>
        </div>
      </form>
    </Sheet>
  );
};

export default SearchModal;
